export default __webpack_public_path__ + "static/PR-211-2-021ddb9eb01fe6b2089a11595def18ca.webp";